<template>
    <v-container>
        <v-layout row wrap >
            <v-flex xs12 md2 ma-1>
                <v-text-field
                    v-model="firstname"
                    label="Nombre "
                    @keyup="applyFilters"
                
                ></v-text-field>                
            </v-flex>

            <v-flex xs12 md2 ma-1>
                <v-text-field
                    v-model="lastname"
                    label="Apellido"
                    @keyup="applyFilters"
                
                ></v-text-field>
            </v-flex>

            <v-flex xs12 md3 ma-1>
                <v-text-field
                    v-model="document"
                    label="Documento"
                    @keyup="applyFilters"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 md2 ma-1>
                <v-select
                    v-model="status"
                    :items="estados"
                    item-text="label"
                    item-value="value"
                    label="Estado"
                    @change="filterStatus"
                ></v-select>
            </v-flex>
        </v-layout>
    </v-container>
    
    </template>
    <script>
    
    export default {
        name: "AptosFiltros",
        props: {
            evento_id: {
                type: Number,
                default: null 
            }
        },
        data() {
            return {
                timeout: null,
                query: '',
                document: '',
                status: '',
                filters: {
                    firstname: '',
                    lastname: '',
                    document: '',
                    status: ''
                }, 
                estados: [
                    { value: '', label: 'Todos' },
                    { value: 'PENDING', label: 'Pendiente' },
                    { value: 'APPROVED', label: 'Aprobado' },
                    { value: 'REJECTED', label: 'Rechazado' }
                ]
            }
        },
        mounted() {
        },
        methods: {
         
            applyFilters: function() {
                this.filters.firstname = this.firstname;
                this.filters.lastname = this.lastname;
                this.filters.document = this.document;         
    
                clearTimeout(this.timeout);            
                var self = this;
                this.timeout = setTimeout(function () {       
                    self.$emit('updateFilter', self.filters);
                }, 500);            
            },
    
            filterStatus(value) {
                this.filters.status = this.status;
                this.$emit('updateFilter', this.filters);
            },
            clearFilters() {
                
                this.filters = {
                    firstname: '',
                    lastname: '',
                    document: '',
                    status: ''
                };
                this.applyFilters();
            }
        }
    }
    </script>